/**
 * Performs a deep equality check between two values.
 * @param {any} a
 * @param {any} b
 * @returns {boolean}
 */
export function deepEqual(a, b) {
    // 1. Check for reference equality
    if (a === b) {
      return true;
    }
  
    // 2. Handle null/undefined vs. non-null objects
    if (a == null || b == null) {
      return a === b; // both null or undefined
    }
  
    // 3. If types differ, not equal
    if (typeof a !== typeof b) {
      return false;
    }
  
    // 4. Handle arrays
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) {
        return false;
      }
      // Compare each element
      for (let i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
  
    // 5. Handle plain objects
    if (typeof a === 'object' && typeof b === 'object') {
      // Compare object keys
      const aKeys = Object.keys(a);
      const bKeys = Object.keys(b);
      if (aKeys.length !== bKeys.length) {
        return false;
      }
      // Check for key-value pairs
      for (let key of aKeys) {
        if (!Object.prototype.hasOwnProperty.call(b, key)) {
          return false;
        }
        if (!deepEqual(a[key], b[key])) {
          return false;
        }
      }
      return true;
    }
  
    // 6. If it's some other type (string, number, boolean, etc.), 
    //    we've already ruled out a === b, so it's false
    return false;
  }
  